import React from 'react';
import Conditional from '../../../common/conditional';

import useProjectDetails from '../../../../hooks/useProjectDetails';
import classNames from './style.module.scss';
import routes from '../../../../utils/routes';

interface CustomReviewDetailsProps {
	inspectorName: string;
	inspectorRole: string;
	inspectorSignature: string;
	inspectionDate: string;
	inspectorQualifications: string;
	reviewerName: string;
	reviewerRole: string;
	reviewerSignature: string;
	reviewDate: string;
	reviewerQualifications: string;
	approverName: string;
	approverRole: string;
	approvalDate: string;
	approverSignature: string;
	approverQualifications: string;
}

const CustomReviewDetails: React.FC<CustomReviewDetailsProps> = (props) => {
	const { projectDetails } = useProjectDetails();

	return (
		<table className={classNames.reviewDetailsTable}>
			<thead>
				<tr>
					<th></th>
					<th>INSPECTED BY</th>
					<th>REVIEWED BY</th>
					<th>APPROVED BY</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className={classNames.titleField}>Name</td>
					<td>{props.inspectorName}</td>
					<td>{props.reviewerName}</td>
					<td rowSpan={4}>
						<div className='mb-3'>
							{props.approverName}
						</div>

						{projectDetails && (
							<a
								href={process.env.REACT_APP_OFFICIAL_URL + routes.projectDetails.fullPath.replace(':projectId', projectDetails._id!) + '#audit-trail'}
								className={classNames.reviewDetailsTableLink}
								target='_blank'
								rel='noopener noreferrer'
							>
								View Details
							</a>
						)}
					</td>
				</tr>
				<Conditional isVisible={false}>
					<tr>
						<td className={classNames.titleField}>Position</td>
						<td>{props.inspectorRole}</td>
						<td>{props.reviewerRole}</td>
						<td>{props.approverRole}</td>
					</tr>
				</Conditional>
				<tr>
					<td className={classNames.titleField}>Qualification</td>
					<td>{props.inspectorQualifications}</td>
					<td>{props.reviewerQualifications}</td>
					<Conditional isVisible={false}>
						<td>{props.approverQualifications}</td>
					</Conditional>
				</tr>
				<tr>
					<td className={classNames.titleField}>Signature</td>
					<td>
						<Conditional isVisible={!!props.inspectorSignature}>
							<img
								src={props.inspectorSignature}
								alt={`Signed By ${props.inspectorName}`}
								className={classNames.reviewDetailsTableSignature}
							/>
						</Conditional>
					</td>
					<td>
						<Conditional isVisible={!!props.reviewerSignature}>
							<img
								src={props.reviewerSignature}
								alt={`Signed By ${props.reviewerName}`}
								className={classNames.reviewDetailsTableSignature}
							/>
						</Conditional>
					</td>
					<Conditional isVisible={false}>
						<td>
								<img
									src={props.approverSignature}
									alt={`Signed By ${props.approverName}`}
									className={classNames.reviewDetailsTableSignature}
								/>
						</td>
					</Conditional>
				</tr>
				<tr>
					<td className={classNames.titleField}>Date:</td>
					<td>{props.inspectionDate}</td>
					<td>{props.reviewDate}</td>
				</tr>
			</tbody>
		</table>
	);
};

export default CustomReviewDetails;
